import Alpine from 'alpinejs';

import customTooltips from '@coreui/chartjs/js/src/custom-tooltips';
import 'jquery-mask-plugin';
import swal from 'sweetalert2';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/draggable';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import skLocale from '@fullcalendar/core/locales/sk';
import csLocale from '@fullcalendar/core/locales/cs';
import Color from 'colorjs.io';
import MultiSelectCustom from './vendor/multi-select';
// import Pace from 'pace-js';

// Pace.options = {
//     ajax: false,
// }

// window.Pace = Pace;
window.Calendar = Calendar;
window.Color = Color;
window.dayGridPlugin = dayGridPlugin;
window.timeGridPlugin = timeGridPlugin;
window.interactionPlugin = interactionPlugin;
window.listPlugin = listPlugin;
window.skLocale = skLocale;
window.csLocale = csLocale;
window.Alpine = Alpine;
window.$ = window.jQuery = require('jquery');
window.toastr = require("toastr");
window.moment = require("moment");
window.Ladda = require('ladda');
window.googleMap = require("./vendor/googlemaps/jquery.googlemap");
window.daterangepicker = require('daterangepicker');
window.select2 = require('select2');
window.datepicker = require('bootstrap-datepicker');
window.Imask = require('imask');
window.hierarchySelect = require('./vendor/hierarchy-select/src/hierarchy-select');
window.swal = swal;
window.MultiSelectCustom = MultiSelectCustom;

require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.cs.min');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.sk.min');

require('./bootstrap');

// CoreUI
require('@coreui/coreui-pro');
window.Utils = require("@coreui/utils");

// Boilerplate
require('./plugins');

import mpnu_content from './alpine/mpnu_content';

Alpine.data('mpnu_content', mpnu_content);

Alpine.start();
Chart.defaults.global.pointHitDetectionRadius = 1
Chart.defaults.global.tooltips.enabled = false
Chart.defaults.global.tooltips.mode = 'index'
Chart.defaults.global.tooltips.position = 'nearest'
Chart.defaults.global.tooltips.custom = customTooltips
Chart.defaults.global.defaultFontColor = "#768192"
